import PageContainer from '@/common/components/PageContainer'
import UpdateRankListing from '@/modules/manage-rank/components/UpdateRank/components/UpdateRankListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function UpdateRankPage() {
	return (
		<PageContainer>
			<UpdateRankListing />
		</PageContainer>
	)
}

const GuardedUpdateRankPage = withUserPermission(UpdateRankPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_RANK],
})

export default GuardedUpdateRankPage
